import React from 'react';
import './css/PlayersSkeletonLoader.css';

// This component renders a skeleton loader for player stats.
function PlayersSkeletonLoader() {
    return (
        <div className="players-loader">
          <div className="players-grid">
            {Array(8)
              .fill(0)
              .map((_, index) => (
                <div className="players-box" key={index}></div>
              ))}
          </div>
        </div>
      );
}

export default PlayersSkeletonLoader;